import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ExpensesViewPage } from '@/areas/manufacturing-templates/Expenses/ExpensesView/ExpensesViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/expenses/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ExpensesViewPage />;
}
